"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
// Automatically generated on publish
exports.VERSION = '3.3.39';
